<template>
    <div class="flex justify-center items-center">
        <h1 class="text-center">
            Deze website is ontwikkeld door <a class="text-red"
                                               href="https://www.linkedin.com/company/protoqol">Protoqol</a>
        </h1>
        <img alt="Protoqol" title="Protoqol" src="/img/protqol.png">
    </div>
</template>

<script>
    export default {
        name: "About"
    }
</script>

<style scoped>

</style>
